















import { defineComponent } from "@vue/composition-api";
import { InputJoinData } from "@scrile/api-provider/dist/api/LoginProvider";
import { getFirstPart } from "@/lib/emailHelpers";
import { $t } from "@/lib/i18nHelpers";
import { loginSignUp } from "@/lib/loginHelpers";
import config from "@/config";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import LoginContainer from "@/components/LoginContainer";
import LoginPhone from "@/components/LoginPhone";

export default defineComponent({
  name: "SignUpComponent",
  components: { BaseForm, BaseButton, LoginContainer, LoginPhone },
  data() {
    return {
      loading: false,
      isValid: false,
      fields: [
        {
          name: "email",
          label: $t("Email"),
          autocomplete: "email",
          type: "email",
          rules: "required",
        },
        {
          name: "password",
          type: "password",
          label: $t("Password"),
          autocomplete: "new-password",
          rules: ["required", "min:3"],
        },
      ] as FormFields,
      values: {} as FormValues,
    };
  },
  computed: {
    signUpByPhone(): boolean {
      return config.featurePhoneSignUp;
    },
  },
  methods: {
    async submit() {
      if (!this.isValid) return;
      let { email, password } = this.values;
      try {
        this.loading = true;
        const data: InputJoinData = {
          email,
          password,
          role: config.userRegistrationRole,
          screenName: getFirstPart(email),
        };
        await loginSignUp(data);
        this.$emit("signup");
      } finally {
        this.loading = false;
      }
    },
  },
});
